import { useCreation, useRequest } from 'ahooks'
import { Image } from 'antd'
import { isEmpty, isNil } from 'lodash'

import { CertificationEntity } from '@eastcoal/api/auth/interface'
import { queryFileDetailApi } from '@eastcoal/api/nexus/oss/queryFileDetail'

import emptyCertificationImag from '../../assets/emptyCertification.png'

type CertificationImageProps = {
  data: CertificationEntity
}

export const CertificationImage = ({ data }: CertificationImageProps) => {
  const ossId = useCreation(
    () => (isNil(data.image) ? undefined : data.image?.split(',')?.[0]),
    [data.image]
  )

  const { data: file } = useRequest(() => queryFileDetailApi({ ossId }), {
    manual: false,
    ready: !!ossId,
    refreshDeps: [ossId]
  })

  return isEmpty(file) ? (
    <img
      alt='资质'
      src={emptyCertificationImag}
      style={{ width: 100, height: 100 }}
    />
  ) : (
    <Image src={file?.accessUrl} style={{ width: 100, height: 100 }} />
  )
}
